import { FORMAS_PAGO } from "../../constants/formasPago";
import "./FormasPagoChips.css";

/**
 * Selección múltiple de formas de pago con chips.
 * - seleccionadas: array de values (ej. ["INFONAVIT", "BANCARIO"])
 * - otro: texto libre cuando se elige "Otro"
 */
export default function FormasPagoChips({ seleccionadas = [], otro = "", onChange, onOtroChange }) {
  const alternar = (value) => {
    const nuevas = seleccionadas.includes(value)
      ? seleccionadas.filter((v) => v !== value)
      : [...seleccionadas, value];
    onChange(nuevas);
    if (value === "OTRO" && seleccionadas.includes("OTRO")) onOtroChange(""); // se quitó "Otro"
  };

  return (
    <div className="form-group">
      <span className="form-label" id="formas-pago-label">
        ¿Cómo planeas pagar?{" "}
        <span className="fp-opcional">(opcional · puedes elegir varias)</span>
      </span>

      <div className="fp-chips" role="group" aria-labelledby="formas-pago-label">
        {FORMAS_PAGO.map((f) => {
          const activa = seleccionadas.includes(f.value);
          return (
            <button
              key={f.value}
              type="button"
              className={`fp-chip ${activa ? "activa" : ""}`}
              aria-pressed={activa}
              onClick={() => alternar(f.value)}
            >
              {activa && <span className="fp-check" aria-hidden="true">✓</span>}
              {f.label}
            </button>
          );
        })}
      </div>

      {seleccionadas.includes("OTRO") && (
        <input
          className="form-input fp-otro"
          value={otro}
          maxLength={100}
          onChange={(e) => onOtroChange(e.target.value)}
          placeholder="¿Cuál? Ej. Cofinavit, crédito familiar..."
          aria-label="Otra forma de pago"
        />
      )}
    </div>
  );
}
